import { h } from 'preact';
import Image from 'utils/image';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Navigation } from 'swiper';
import { useEffect, useRef } from 'preact/hooks';

const CategorySlider = ({ collections }) => {
  const sliderRef = useRef(null);

  useEffect(() => {
    if (sliderRef.current) {
      setTimeout(() => {
        sliderRef.current.swiper.update();
      }, 100);
    }
  }, [collections]);
  if (!collections.length) return null;
  return (
    <div className="container !block">
      <Swiper
        ref={sliderRef}
        className="container !flex !overflow-visible"
        modules={[Navigation, FreeMode]}
        navigation={{
          prevEl: '.category-slider-arrows.prev',
          nextEl: '.category-slider-arrows.next',
          clickable: true,
        }}
        centeredSlides={false}
        centerInsufficientSlides={true}
        spaceBetween={8}
        loop={false}
        watchOverflow={true}
        watchSlidesProgress={true}
        allowTouchMove={true}
        slidesPerView="auto"
        freeMode={true}
        slidesOffsetAfter={0}
        resizeObserver={false}
      >
        {collections.map((collection) => (
          <SwiperSlide
            className="swiper-slide [&.swiper-slide]:w-[150px] [&.swiper-slide]:md:w-[205px] group"
            key={collection.id}
          >
            <a href={collection.url} className="block relative overflow-hidden">
              {!!collection.image && (
                <Image
                  {...collection.image}
                  classes="object-cover h-[206px] md:h-[281px] lc:rounded-10"
                />
              )}
              {!collection.image && (
                <div className="w-full ml:w-full h-[206px] md:h-[281px] bg-accent-1"></div>
              )}
            </a>
            <div className="mt-8 text-center body-2 group-hover:[&>a]:body-2-underline [&>a]:line-clamp-2">
              <a href={collection.url}>{collection.title}</a>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default CategorySlider;
